import { useAppSelector } from '../data/store';

const SuccessMessage = () => {
    const isSuccess = useAppSelector(store => store.root.isSuccess);

    return (
        isSuccess ? <div className="ok-box text-sm mt-8" role="alert">
            <p>A link to reset your password has been sent to your email.</p>
        </div> : <></>
    )
};

export default SuccessMessage;